import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import AddCardIcon from "@mui/icons-material/AddCard";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { handleError } from "../../../utils/handleError";
import toast from "react-hot-toast";
import { fetchNewSessionPayment } from "../../../services/rest/membership/membershipService";
import { useSelector } from "react-redux";

const ListCardsAction = ({ setOpen, setLoading, setShowModalSuccess }) => {
  const { planName, membershipStatus } = useSelector(
    (state) => state.membershipReducer
  );
  const { _id } = useSelector((state) => state.userReducer);

  const cardsActions = [
    {
      id: 1,
      action: "Pagar membresía.",
      icon: (
        <AddCardIcon
          sx={{
            fontSize: 30,
            color: membershipStatus !== "active" ? "#ced38f" : "#e7ef7d",
          }}
        />
      ),
      actionOnPress: {
        action: "handlePayment",
        navigate: "",
      },
    },
    {
      id: 2,
      action:
        membershipStatus !== "active"
          ? "Seleccionar membresía"
          : "Actualizar membresía",
      icon: <CardMembershipIcon sx={{ fontSize: 30, color: "#e7ef7d" }} />,
      actionOnPress: {
        action: "navigate",
        navigate: "/dashboard/list-memberships",
      },
    },
    {
      id: 3,
      action: "Detalles de membresía",
      icon: <CardGiftcardIcon sx={{ fontSize: 30, color: "#e7ef7d" }} />,
      actionOnPress: { action: "showModal", navigate: "" },
    },
  ];

  const handlePaymentLink = async () => {
    try {
      if (membershipStatus !== "active") {
        toast.error("Selecciona una membresía.");
        return;
      }
      setLoading(true);
      const response = await fetchNewSessionPayment({
        membershipType: planName,
        userId: _id,
      });
      setShowModalSuccess(true);
      window.open(response?.url, "_blank");
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`En este momento no podemos generar su pago. \n ${message}`);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        gap: 4,
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {cardsActions.map((action) => (
        <Link
          style={{ textDecoration: "none" }}
          to={action?.actionOnPress?.navigate}
          key={action?.id}
          onClick={() => {
            action?.actionOnPress?.action === "showModal"
              ? setOpen(true)
              : action?.actionOnPress?.action === "handlePayment" &&
                handlePaymentLink();
          }}
        >
          <Box
            sx={{
              backgroundColor: "rgba(128, 128, 128, 0.55)",
              display: "flex",
              flexDirection: "column",
              padding: 2,
              width: 150,
              borderRadius: 3,
              alignItems: "center",
            }}
          >
            {action?.icon}
            <Typography sx={{ color: "white", textAlign: "center" }}>
              {action?.action}
            </Typography>
          </Box>
        </Link>
      ))}
    </Box>
  );
};

export default ListCardsAction;
